<script>

  import BaseInput from "@/public/pages/integration-settings/components/Input/index.vue";
  import BaseButton from "@/public/components/common/uiKit/button/base/index.vue";
  import {mapActions, mapMutations, mapState} from "vuex";
  import InfoButton from "@/public/components/common/uiKit/info-button/index.vue";
  import DeleteButton from "@/public/components/common/uiKit/delete-button/index.vue";

  export default {
    name: "OrganizationNewUsers",
    components: {DeleteButton, InfoButton, BaseButton, BaseInput},
    methods: {
      ...mapMutations('organizations', ['switchTab', 'changeDetailRole']),
      ...mapActions('organizations', [
        'getOrganizationUsers',
        'getOrganizationRoles',
      ]),
      ...mapActions('app', ['openModal']),
      handleAddUser() {
        this.switchTab(1)
        this.changeDetailRole(false)
        this.getOrganizationUsers()
      },
      deleteUser(user) {
        this.openModal({
          name: 'RemoveUserModal',
          payload: {
            user,
          },
        });
      },

      changeUser(user) {
        this.openModal({
          name: 'UpdateUserModal',
          payload: {
            user,
          },
        });
      },
    },
    computed: {
      ...mapState('organizations', [
        'organizationData',
      ]),
      list () {
        if (!this.organizationData.organizationUsers.length) return []
        return this.organizationData.organizationUsers.slice(0, 5)
      }
    }
  }
</script>

<template>
<div class="organization-information">
  <div class="header">
    <div class="header__left">
      <div class="header__title">
        {{ $t('organization.organization-new-users') }}
      </div>
    </div>
  </div>
  <div class="list">
    <div class="header">
      <div class="col">{{ $t('organization.list.user') }}</div>
      <div class="col">{{ $t('organization.list.role') }}</div>
    </div>
    <template v-if="list.length">
      <div v-for="item in list" :key="item.id" class="item">
        <div class="item__values">
          <div class="item__value">{{ item.name}}</div>
          <div class="item__value">{{ item.role.name }}</div>
        </div>
        <div class="item__actions">
          <info-button @click="changeUser(item)" />
          <delete-button @click="deleteUser(item)"/>
        </div>
      </div>
    </template>
    <p class="empty" v-else> {{ $t('organization.no-users') }} </p>

  </div>
  <div class="more-btn">
    <base-button @click="handleAddUser" :label="list.length ? $t('organization.more') : $t('organization.organization_btn_add')" />
  </div>
</div>
</template>

<style scoped lang="scss">
.organization-information {
  border-radius: 20px;
  background: var(--bg-background-secondary, #202020);
  padding: 30px;
  font-family: $Gilroy;

  .header {
    display: flex;
    justify-content: space-between;
    margin-bottom: 30px;
    &__title {
      color: var(--text-text-primary, #FFF);
      font-family: Gilroy;
      font-size: 24px;
      font-style: normal;
      font-weight: 500;
      line-height: 24px;
    }
    &__left {
      display: flex;
      align-items: center;
      gap: 5px;
    }
    &__right {
      display: grid;
      grid-template-columns: 48px 1fr;
      gap: 10px;
    }
    &__clear {
      border-radius: 10px;
      border: 1px solid var(--button-border-button-primary-default, #6750A4);
      width: 48px;
      height: 48px;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    &__button {
      width: 180px;
    }
  }
  .list {
    margin-bottom: 30px;
    .empty {
      color: var(--text-color-text-secondary, #7E7E7E);
      text-align: center;
      font-size: 16px;
      font-style: normal;
      font-weight: 500;
      line-height: normal;
      margin-top: 30px;
    }
    .header {
      border-radius: 10px;
      background: var(--bg-background-table, #333);
      padding: 0 20px;
      height: 56px;
      display: grid;
      grid-template-columns: 1fr 1fr 168px;
      margin-bottom: 0;
      .col {
        color: var(--text-color-text-secondary, #7E7E7E);
        font-size: 16px;
        font-style: normal;
        font-weight: 500;
        line-height: normal;
        display: flex;
        align-items: center;
        gap: 5px;
        padding-left: 0 !important;
        padding-right: 0 !important;
      }
    }
    .item {
      display: grid;
      grid-template-columns: 1fr 168px;
      align-items: center;
      border-bottom:   1px solid var(--border-devider-primary, #353537);
      padding: 10px 20px 10px 20px;
      &__values {
        display: grid;
        grid-template-columns: 1fr 1fr;
      }

      &:last-child {
        border-bottom: none;
      }
      &__value {
        color: var(--text-text-primary, #FFF);
        font-size: 16px;
        font-style: normal;
        font-weight: 500;
        line-height: 24px; /* 150% */
      }
      &__actions {
        display: grid;
        grid-template-columns: 48px 48px;
        gap: 10px;
        justify-content: end;
        &-btn {
          cursor: pointer;
          height: 48px;
          width: 48px;
          display: flex;
          align-items: center;
          justify-content: center;
          border-radius: 10px;
          border: 1px solid var(--button-border-button-primary-default, #6750A4);
          &.history {
            span {
              display: none;
            }
          }
        }
      }
    }
  }
}
@media screen and (max-width: 768px) {
  .organization-information {
    padding: 0;
    //.header {
    //  display: none;
    //}
    .header {
      padding: 20px 0 15px 20px;
      margin-bottom: 0;
      border-bottom: 1px solid var(--border-devider-primary, #353537);;
    }
    .header__left {
      .header__title {
        font-size: 16px;
      }
    }
    .list {
      .header {
        display: none;
      }
      .item {
        padding: 16px 20px 20px 20px;
        height: unset;
        grid-template-columns: 1fr;
        border-bottom: 1px solid var(--border-devider-primary, #353537);
        &:last-child {
          border-bottom: 0;
        }
        &__value {
          color: var(--text-color-text-secondary, #7E7E7E);
          font-size: 13px;
          &:first-child {
            color: var(--text-text-primary, #FFF);
          }
          &:nth-child(even) {
            display: flex;
            justify-content: flex-end;
          }
        }
        &__values {
          grid-template-columns: 1fr 1fr;
        }
        &__actions {
          margin-top: 20px;
          grid-template-columns: 48px 48px;
          justify-items: right;
          &-btn {
            gap: 8px;
            &.history {
              width: unset;
              color: var(--bg-background-primary-purple, #6750A4);
              text-align: right;
              font-size: 13px;
              font-weight: 500;
              line-height: 28px;
              span {
                display: inline-block;
              }
            }
          }
        }
      }
    }
    .more-btn {
      margin-top: 30px;
      padding: 0 20px 20px 20px;
    }

  }
}
</style>
